// extracted by mini-css-extract-plugin
export var container = "_bw-0";